import React, { useRef, useState } from "react";
import axios from "axios";
import { apiUrl } from "../config/Config.js";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { PhoneInput, defaultCountries } from "react-international-phone";
import "react-international-phone/style.css";
import { Modal, Button } from "react-bootstrap";
import { registrationErrorMessage } from "../utils/registrationError";

const RegisterPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    address: "",
    email: "",
    profession: "",
    password: "",
    repassword: ""
  });
  const [registrationsuccessfullmodal, setregistrationsuccessfullmodal] = useState(false);

  const indiaOnlyCountries = defaultCountries.filter(
    (country) => country[1] === "in"
  );

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [nameerrormessage, setnameerrormessage] = useState("");
  const [numbererrormessage, setnumbererrormessage] = useState("");
  const [emailerrormessage, setemailerrormessage] = useState("");
  const [professionalerrormessage, setprofessionalerrormessage] = useState("");
  const [passworderrormessage, setpassworderrormessage] = useState("");
  const [retypeerrormessage, setretypeerrormessage] = useState("");
  const [passwordnotmatchmessage, setpasswordnotmatchmessage] = useState("");

  const [resultusername, setresultusername] = useState("");

  const resultusernameRef = useRef("");
  resultusernameRef.current = resultusername;

  // ✅ Only Valid Input Allowed While Typing
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Validation Rules
    if (name === "name") {
      const regex = /^[A-Za-z\s]*$/;
      if (!regex.test(value)) return; // ❌ Block invalid characters
    }

    if (name === "mobile") {
      const regex = /^[0-9]*$/;
      if (!regex.test(value)) return;
      if (value.length > 10) return;
    }

    if (name === "email") {
      if (value.includes(" ")) return; // ❌ No spaces allowed
    }

    if (name === "password") {
      if (value.includes(" ")) return; // ❌ No spaces allowed
    }

    setFormData({ ...formData, [name]: value });
  };

  // ✅ Form Validation on Submit
  const validateForm = () => {
    if (formData.name.trim().length < 3)
      return alert("Full Name must be minimum 3 letters.");

    if (formData.mobile.length < 10)
      return alert("Enter valid 10-digit Mobile Number.");

    // if (formData.address.trim().length < 5)
    //   return alert("Address must be minimum 5 characters long.");

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(formData.email?.length > 0) {
      if (!emailRegex.test(formData.email))
        return alert("Enter valid Email ID.");
    }
    

    if (formData.password.length < 6)
      return alert("Password must be at least 6 characters.");

    if (formData.repassword.length < 6)
      return alert("Password must be at least 6 characters.");

    if(formData.password !== formData.repassword)
      return alert("Password & Re-password should be same");

    return true;
  };

  const loadScript = (src) => {
    return new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = () => { resolve(true); };
        script.onerror = () => { resolve(false); };
        document.body.appendChild(script);
    });
};

const generateRandom22DigitNumber = (maxnum) => {
  let randomNumber = '';
  while (randomNumber.length < maxnum) {
      randomNumber += Math.floor(Math.random() * 10);
  }
  return randomNumber;
}

// const data1 = {
//   fullname: formData.name,
//   number: mobile,
//   address: formData.address,
//   email: formData.email,
//   password: formData.password,
//   username: result
// };

const paymentsuccessfunction = async(userid, amount, paymentResponse) => {
  console.log('paymentid >>', paymentResponse.razorpay_payment_id);
  const data = {
    userid: userid,
    paymentid: paymentResponse.razorpay_payment_id,
    orderid: paymentResponse.razorpay_order_id,
    signature: paymentResponse.razorpay_signature,
    purpose: "registration",
    amount: amount,
    // contriamount: (amount / 2).toFixed(2)
    contriamount: ((70 / 100) * amount).toFixed(2)
  };
  try {
    const res = await axios.post(apiUrl + "updatepaymentstatus", data, {
      headers: { "Content-Type": "application/json" },
    });

    if (res.data.status === "success") {
      setFormData({
          name: "",
          mobile: "",
          address: "",
          email: "",
          password: "",
          profession: "",
          repassword: ""
        });
        setLoading(false);
        setregistrationsuccessfullmodal(true);
      // alert("Registered Successfully!");
    } else {
      alert(res.data.message || "Registration Failed.");
      setLoading(false);
    }
  } catch (err) {
    console.error("API Error:", err);
    alert(`${registrationErrorMessage(err, "Payment confirmation failed.")} If money was deducted, do not pay again. Contact support with your payment ID: ${paymentResponse.razorpay_payment_id}`);
    setLoading(false);
  }

}

  const loadRazorpay = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const generateUserCode = (fullName, mobileNumber) => {
    if (!fullName || !mobileNumber) return '';
  
    // Get first letter of each word and join WITHOUT separator
    const initials = fullName
      .trim()
      .split(/\s+/)
      .map(word => word.charAt(0).toUpperCase())
      .join('');
  
    // Get last 4 digits of mobile number
    const last4Digits = mobileNumber.toString().slice(-4);
  
    return `${initials}-${last4Digits}`;
  }

  const normalizeAndValidateIndianMobile = (input) => {
    if (!input) return { isValid: false, mobile: '' };
  
    // remove spaces, hyphens, brackets, etc.
    let digits = String(input).replace(/\D/g, '');
  
    // remove country code 91 if present
    if (digits.length === 12 && digits.startsWith('91')) {
      digits = digits.slice(2);
    }
  
    // remove leading zero
    if (digits.length === 11 && digits.startsWith('0')) {
      digits = digits.slice(1);
    }
  
    // must be exactly 10 digits
    if (!/^[6-9]\d{9}$/.test(digits)) {
      return { isValid: false, mobile: '' };
    }
  
    return { isValid: true, mobile: digits };
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    // if (!validateForm()) return;

    var isnameerror = false;
    var ismobileerror = false;
    var isemailerror = false;
    var isprofessionerror = false;
    var ispassworderror = false;
    var isrepassworderror = false;

    if(formData.name.trim().length >= 3 && formData.name.trim().length <= 255) {
      setnameerrormessage("");
      isnameerror = false;
    } else {
      setnameerrormessage("Full name must be between 3 and 255 characters");
      isnameerror = true;
    }

    if(formData.mobile) {
      if(formData.mobile?.length < 4) {
        setnumbererrormessage("Mobile number cannot be empty.");
        ismobileerror = true;
      } else {
        setnumbererrormessage("");
        ismobileerror = false;
      }    
    } else {
      setnumbererrormessage("Number cannot be empty");
      ismobileerror = true;
    }

    if(formData.email) {
      if(validateEmail(formData.email)) {
        setemailerrormessage("");
        isemailerror = false;
      } else {
        setemailerrormessage("Invalid Email ID");
        isemailerror = true;
      }
      
    } else {
      setemailerrormessage("");
      isemailerror = false;
    } 

    if(formData.profession) {
      setprofessionalerrormessage("");
      isprofessionerror = false;
    } else {
      setprofessionalerrormessage("Profession cannot be empty")
      isprofessionerror = true;
    }

    if(formData.password.length >= 6 && formData.password.length <= 255) {
      setpassworderrormessage("");
      ispassworderror = false;
    } else {
      setpassworderrormessage("Password must be between 6 and 255 characters")
      ispassworderror = true;
    }

    if(formData.repassword) {
      setretypeerrormessage("");
      isrepassworderror = false;
    } else {
      setretypeerrormessage("Re-Password cannot be empty")
      isrepassworderror = true;
    }


    // if(!nameerrormessage && !numbererrormessage && !emailerrormessage && !professionalerrormessage && !passworderrormessage && !retypeerrormessage) {
    //   if(formData.password == formData.repassword) {
    //     setpasswordnotmatchmessage("")
    //     alert('Form is validated!!');
    //   } else {
    //     console.log('password not matching!!');
    //     setpasswordnotmatchmessage("Password & Re-type password does not match!!");
    //   }
    // } else {
    //   console.log('error >>')
    //   return;
    // }

    if(!isnameerror && !ismobileerror && !isemailerror && !isprofessionerror && !ispassworderror && !isrepassworderror) {
      if(formData.password == formData.repassword) {
        setpasswordnotmatchmessage("")
        // alert('Form is validated!!');
      } else {
        console.log('password not matching!!');
        setpasswordnotmatchmessage("Password & Re-type password does not match!!");
        return;
      }
    } else {
      console.log('error >>')
      return;
    }

    

    const { isValid, mobile } = normalizeAndValidateIndianMobile(formData.mobile);
    if (!isValid) {
      setnumbererrormessage("Invalid mobile number")
      return;
    } else {
      setnumbererrormessage("");
      console.log('valid mobile number')
    }


    const result = generateUserCode(formData.name, mobile);
    console.log('result >>', result);
    setresultusername(result);



    const data1 = {
      fullname: formData.name.trim(),
      number: mobile,
      address: formData.address,
      email: formData.email,
      password: formData.password,
      username: result
    };

    setLoading(true);

    


    try {
      const res = await axios.post(apiUrl + "userregister", data1, {
        headers: { "Content-Type": "application/json" },
      });

      if (res.data.status === "success") {
        // alert("Registered Successfully!");

        const userid = res.data.userid;

        // displayrazorpay(1, userid);




        // Commented start from here

        try {
          const { data } = await axios.post(apiUrl+"createrazorpayorder", {
            purpose: "registration",
          });

          const res = await loadRazorpay();
        if (!res) {
          alert("Razorpay SDK failed to load");
          setLoading(false);
          return;
        }
  
          const options = {
            key: data.key,
            amount: data.amount * 100,
            currency: data.currency,
            name: "THEOMSAGA",
            description: "",
            order_id: data.order_id,
            handler: function (response) {
              // alert("Payment Successful! Payment ID: " + response.razorpay_payment_id);
              paymentsuccessfunction(userid, data.amount, response);
              console.log(response);
            },
            modal: {
              ondismiss: function () {
                console.log("User closed the payment popup ❌");
                // 👉 Call your function here
                // handlePaymentExit();
                setLoading(false);
              }
            },
            prefill: {
                          name: formData.name,
                          email: formData.email,
                          contact: formData.mobile,
                      },
            theme: {
              color: "#3399cc",
            },
            method: {
              upi: true
            }
          };
    
          const rzp = new window.Razorpay(options);
          rzp.open();
  
        } catch (error) {
          console.error("Payment error:", error);
          alert(registrationErrorMessage(error, "Unable to open payment checkout. Please try registering again to resume your pending payment."));
          setLoading(false);
        } finally {
          // setLoading(false);
        }

      } else {
        alert(res.data.message || "Registration Failed.");
        setLoading(false);
      }
    } catch (err) {
      console.error("API Error:", err);
      alert(registrationErrorMessage(err, "Unable to complete registration. Please try again."));
      setLoading(false);
    }

    // setLoading(false);
  };

  const handleLoginClick = () => {
    navigate("/login");
  };

  return (
    <>
      <Helmet>
        {/* Meta Title */}
        <title>Register | Join TheOmSaga Community</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Join TheOmSaga to read, write, and share spiritual stories. Create your account and begin your storytelling journey."
        />

        {/* NOINDEX for SEO safety */}
        <meta name="robots" content="noindex, nofollow" />

        {/* Canonical */}
        <link rel="canonical" href="https://theomsaga.com/register" />

        {/* Open Graph Tags */}
        <meta property="og:title" content="Join THEOMSAGA" />
        <meta
          property="og:description"
          content="Become part of a spiritual storytelling community."
        />
        <meta property="og:url" content="https://theomsaga.com/register" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://theomsaga.com/assets/images/register-banner.webp"
        />

        {/* Schema Markup */}
        <script type="application/ld+json">
          {`
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": "https://theomsaga.com/register#webpage",
      "name": "Register on TheOmSaga",
      "url": "https://theomsaga.com/register",
      "description": "Register on TheOmSaga to join a spiritual storytelling community and share real-life spiritual stories.",
      
            "sameAs": [
                  "https://www.instagram.com/theomsaga20?igsh=MWNnN3E0NGVleTltZw==",
                  "https://www.facebook.com/share/1B44vEtGc7/"
                ]
      "isPartOf": {
        "@type": "WebSite",
        "name": "TheOmSaga",
        "url": "https://theomsaga.com"
      }
    }
    `}
        </script>
      </Helmet>

      <div className="register-page-container">
        <div className="register-page-scroll">
          <div>
            <p className="register-page-title">REGISTER</p>
          </div>

          <form className="register-page-form" onSubmit={handleSubmit}>
            <div className=" row">
              <div className="col-12 col-md-6">
              <input
                className="register-page-input"
                type="text"
                name="name"
                placeholder="Full Name *"
                value={formData.name}
                onChange={handleChange}
              />
              {
                nameerrormessage ?
                <p className="register-error-message">{nameerrormessage}</p> : null
              }
              </div>
              <div className="col-12 col-md-6">
              <PhoneInput
                defaultCountry="in"
                countries={indiaOnlyCountries}
                hideDropdown
                forceDialCode
                disableCountryGuess
                name="mobile"
                value={formData.mobile}
                onChange={(e) => {setFormData({ ...formData, "mobile": e })}}
                style={{marginBottom: 15}}
              />
              {
                numbererrormessage ?
                <p className="register-error-message">{numbererrormessage}</p> : null
              }
              </div>
              

              {/* <input
                className="register-page-input"
                type="tel"
                name="mobile"
                placeholder="Mobile No *"
                value={formData.mobile}
                onChange={handleChange}
                maxLength={10}
                required
              /> */}

              
            </div>

            {/* <textarea
            className="register-page-input register-page-textarea"
            name="address"
            placeholder="Address *"
            value={formData.address}
            onChange={handleChange}
            required
          /> */}

            <div className=" row">
              <div className="col-12 col-md-6">
              <input
                className="login-page-input"
                type="text"
                name="email"
                placeholder="Email "
                value={formData.email}
                onChange={handleChange}
              />
              {
                emailerrormessage ?
                <p className="register-error-message">{emailerrormessage}</p> : null
              }
              </div>
              <div className="col-12 col-md-6">
              <select
                className="login-page-input"
                name="profession"
                value={formData.profession}
                onChange={handleChange}
              >
                <option value={""} disabled>
                  Select Profession *
                </option>
                <option value={"Working Professional"}>
                  Working Professional
                </option>
                <option value={"Business"}>Business</option>
                <option value={"Homemaker/Housewife"}>
                  Homemaker/Housewife
                </option>
                <option value={"Student"}>Student</option>
                <option value={"Retired"}>Retired</option>
                <option value={"Currently on break from work"}>
                  Currently on break from work
                </option>
                <option value={"Others"}>Others</option>
              </select>
              {
                professionalerrormessage ?
                <p className="register-error-message">{professionalerrormessage}</p> : null
              }
              </div>
            </div>
            <div className=" row">
              <div className="col-12 col-md-6">
              <input
                className="login-page-input"
                type="password"
                name="password"
                placeholder="Password *"
                value={formData.password}
                onChange={handleChange}
              />
              {
                passworderrormessage ?
                <p className="register-error-message">{passworderrormessage}</p> : null
              }
              </div>
              <div className="col-12 col-md-6">
              <input
                className="login-page-input"
                type="password"
                name="repassword"
                placeholder="Re-type Password *"
                value={formData.repassword}
                onChange={handleChange}
              />
              {
                retypeerrormessage ?
                <p className="register-error-message">{retypeerrormessage}</p> : null
              }
              </div>
            </div>

            {
              passwordnotmatchmessage ?
              <p className="register-error-message">{passwordnotmatchmessage}</p> : null
            }


            <button
              className="register-page-button"
              type="submit"
              disabled={loading}
            >
              {loading ? "Registering..." : "Register"}
            </button>
          </form>

          <div className="register-page-mantra">
            <p>
              Already have an account?{" "}
              <button
                type="button"
                className="register-page-loginlink"
                onClick={handleLoginClick}
              >
                login here
              </button>
              .
            </p>
          </div>
        </div>
      </div>

      <Modal
      show={registrationsuccessfullmodal}
      onHide={() => setregistrationsuccessfullmodal(false)}
      centered
      size="md"
      backdrop="static"
      className="registrationsuccessfullmodal"
    >
      <Modal.Body className="p-4">
        {/* Header */}
        <div className="text-center mb-3">
          <div className="success-icon mb-2">🎉</div>
          <h5 className="fw-bold">
            Your registration with <span className="text-primary">THEOMSAGA</span>
            <br /> has been completed successfully!
          </h5>
        </div>

        {/* Description */}
        

        {/* Details Card */}
        {
          resultusernameRef.current ?
          <>
            <p className="text-muted text-center mb-4">
          We’re excited to have you on board. Below are your registration details
          for future reference:
        </p>
        <div className="details-card mb-3">
          <div className="detail-row">
            <span className="label">User ID</span>
            <span className="value fw-semibold">{resultusernameRef.current}</span>
          </div>
          </div>
          </>
          

         : null
        }
        

        {/* Info Text */}
        <p className="small text-muted mb-2">
          🔐 Please keep your <strong>User ID</strong> safe. It will be required
          for future communication and support.
        </p>

        <p className="small text-muted">
          If you did not register on THEOMSAGA, please contact our support team
          immediately.
        </p>

        {/* Footer Button */}
        <div className="text-center mt-4">
          <Button variant="primary continuebtn" onClick={() => { 
            navigate("/login");
            }}>
            Continue
          </Button>
        </div>
      </Modal.Body>
    </Modal>
    </>
  );
};

export default RegisterPage;
